export const APPLICATION_MODE = {
	Development: "development",
	DevTools: "dev-tools",
	MarketingTools: "marketing-tools",
	Platform: "platform",
	Staging: "staging",
	Production: "production",
} as const;
